<template>
  <div class="realtime-container" :class="'isMore' + isMore">
    <div class="top-map">
      <div v-show="isMore!==2" class="search-view">
        <el-select v-model="curPoint" filterable  clearable :placeholder="$t('operate.name80')" @change="changeMarker">
          <el-option v-for="item in points" :key="item.ebikeId" :label="item.ebikeId" :value="item.ebikeId" />
        </el-select>
      </div>
      <div class="maps-change">
        <el-radio-group v-model="mapType" size="mini" @change="changeMap">
          <el-radio-button :label="$t('operate.name74')" />
          <el-radio-button :label="$t('operate.name73')" />
        </el-radio-group>
      </div>
      <div v-if="mapType===$t('operate.name74')" class="map-item">
        <baidu-map class="map" :center="mapCenter" :zoom="mapZoom" :scroll-wheel-zoom='true' @ready="handleMap">
          <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT" />
          <!-- 在地图中添加一个信息窗体 -->
          <bml-marker-clusterer :averageCenter="true">
            <bm-marker
                v-for="(item,index) in points"
                :key="index"
                :position="{ lng: item.lng, lat: item.lat}"
                @click="clickMarker(item)"
                :icon="{url: require(item.status===0?'../../../assets/bikered.png':'../../../assets/bikeblue.png'), size: {width: 50, height: 30},opts: {imageSize: {width: 50,height: 30}}}">
            </bm-marker>
          </bml-marker-clusterer>
          <bm-info-window  :position="{lng: infoWindow?.lng, lat: infoWindow?.lat}" :show="infoWindowShow" @close="closeInfo">
            <div class="infowindow-view">
              <div>{{ $t('bike.name65') }}{{infoWindow?.ebikeId}}</div>
              <div>{{ $t('bike.name295') }}{{infoWindow?.ebikeCode}}</div>
              <div>{{ $t('bike.name492') }}{{infoWindow?.mac}}</div>
              <div>{{ $t('bike.name493') }}{{infoWindow?.tenantName}}</div>
              <div>{{ $t('bike.name168') }}{{infoWindow?.keepliveTime}}</div>
              <div>{{ $t('bike.name171') }}{{infoWindow?.alt}}</div>
              <div v-if="infoWindow?.speed === '--'">{{ $t('bike.name216') }}--</div>
              <div v-else>{{ $t('bike.name216') }}{{Number(infoWindow?.speed / 10).toFixed(1)}}</div>
              <div>{{ $t('bike.name217') }}{{infoWindow?.soc}}</div>
              <div>{{ $t('bike.name494') }}{{[$t('home.name28'), $t('home.name29')][infoWindow?.lockStatus]}}</div>
              <div>{{ $t('bike.name35') }}{{[$t('bike.name113'), $t('bike.name228'), $t('home.name30')][infoWindow?.status] || '--'}}</div>
              <div>{{ $t('bike.name220') }}{{Number(infoWindow?.batteryTemp) + Number(infoWindow?.batteryTemperatureShowDeviation)}}</div>
            </div>
          </bm-info-window>
        </baidu-map>
        <baidu-map class="hot-map" :center="mapCenterHot" :zoom="mapZoomHot" :scroll-wheel-zoom='true'>
          <bml-heatmap :data="hotmarkersbaidu" :max="maxHot" :radius="20"   />
        </baidu-map>
      </div>
      <GmapMap v-if="mapType===$t('operate.name73')" :center="mapCenter" :zoom='mapGZoom' class="map-item" ref="mapRef">
        <gmap-cluster>
        <gmap-info-window :options="infoOptionsgoole" :position="infoWindowPosgoole" :opened="infoWinOpengoole"
                                @closeclick="infoWinOpengoole=false">
              </gmap-info-window>
          <gmap-marker
          v-for="(item, index) in points"
          :key="index"
          :position="{ lng: item.lng, lat: item.lat}"
          :icon="item.status===0 ? bikeredIcon : bikeblueIcon"
          :clickable="true"
          @click="infowindowgoole(item,index)">
        </gmap-marker>
      </gmap-cluster>
        </GmapMap>
            <HeatMap
            class="hot-gmap"
              v-if="mapType===$t('operate.name73') && hotmarkersgoole.length > 0"
              :initialZoom='2'
              :points="hotmarkersgoole"
              :lat="mapCenter.lat"
              :lng="mapCenter.lng"
            />
    </div>
    <div class="open-view">
      <el-button v-show="isMore !== 1" icon="el-icon-arrow-down" type="info" size="mini" @click="changeMore(1)"></el-button>
      <el-button v-show="isMore !== 2" icon="el-icon-arrow-up" type="info" size="mini" @click="changeMore(2)"></el-button>
    </div>
    <div class="bottom-list">
      <div class="tabs">
        <div v-for="item in tabs" :key="item.type" class="tabs-item" :class="activeName===item.type?'active':''" @click="handleClick(item)">{{item.label}}（{{item.value}}）</div>
      </div>
      <el-table :data="warnList" height="calc(100% - 40px)" :highlight-current-row="true" @row-click="clickMarker">
        <el-table-column :label="$t('finance.name40')" align="center" prop="tenantName" />
        <el-table-column :label="$t('finance.name28')" align="center" prop="ebikeId" />
        <el-table-column :label="$t('bike.name40')" align="center" prop="mac" />
        <el-table-column :label="$t('bike.name43')" align="center" prop="controllerVersion" />
        <el-table-column :label="$t('bike.name106')" align="center" prop="meterVersion" />
        <el-table-column :label="$t('bike.name107')" align="center" prop="iotVersionNo" />
        <el-table-column :label="$t('home.name26')" align="center" prop="soc" />
        <!--  /车锁的状态  0已解锁  1已上锁-->
        <el-table-column :label="$t('bike.name225')" align="center" prop="lockStatus">
          <template slot-scope="scope">
            {{[$t('home.name28'), $t('home.name29')][scope.row.lockStatus]}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('home.name27')" align="center" prop="status">
          <!--  0：已经坏的  1：正常可用的  2：正在使用的-->
          <template slot-scope="scope">
            {{[$t('bike.name113'), $t('bike.name228'), $t('home.name30')][scope.row.status]}}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { findEbikeNewGisProfileList } from '@/api/realtime.js'
import { BmlMarkerClusterer, BmlHeatmap } from 'vue-baidu-map'
import customMarker from '@/assets/bike.png'
import { mapGetters } from 'vuex'
import coordtransform from 'coordtransform'
import GmapCluster from 'vue2-google-maps/src/components/cluster'
import HeatMap from '@/components/HeatMap'
export default {
  computed: {
    ...mapGetters(['userinfo'])
  },
  components: {
    BmlMarkerClusterer,
    BmlHeatmap,
    GmapCluster,
    HeatMap
  },
  data() {
    return {
      map: null,
      BMap: null,
      curPoint: '',
      mapType: this.$t('operate.name74'),
      mapCenter: {
        lng: Math.random() * 40 + 85,
        lat: Math.random() * 30 + 21
      },
      customMarker: customMarker,
      mapZoom: 10,
      mapGZoom: 16,
      mapZoomHot: 1,
      mapCenterHot: {
        lng: 0,
        lat: 0
      },
      hotmarkersgoole: [],
      infoWindowPosgoole: null,
      infoWinOpengoole: false,
      currentMidxgoole: null,
      infoOptionsgoole: {
        content: '',
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      infoWindowShow: false,
      infoWindow: null,
      points: [],
      allPoints: [],
      hotmarkersbaidu: [],
      maxHot: 0,
      activeName: 'all',
      bikeblueIcon: {
        url: require('@/assets/bikeblue.png'),
        size: {
          width: 50,
          height: 30
        },
        scaledSize: {
          width: 50,
          height: 30
        }
      },
      bikeredIcon: {
        url: require('@/assets/bikered.png'),
        size: {
          width: 50,
          height: 30
        },
        scaledSize: {
          width: 50,
          height: 30
        }
      },
      tabs: [
        { label: this.$t('home.name23'), type: 'all', typevalue: 2, value: 0 },
        { label: this.$t('home.name24'), type: 'online', typevalue: 1, value: 0 },
        { label: this.$t('home.name25'), type: 'error', typevalue: 0, value: 0 }
      ],
      isMore: 0,
      warnList: [],
      onlineList: [],
      faultList: []
    }
  },
  created() {},
  mounted() {
    // this.getPoints()
  },
  methods: {
    addPoints () {
      this.hotmarkersbaidu = []
      for (var i = 0; i < 10; i++) {
        const position = { lng: Math.random() * 40 + 85, lat: Math.random() * 30 + 21, count: parseInt(Math.random() * 10) }
        this.hotmarkersbaidu.push(position)
        if (i === 2) {
          this.mapCenterHot.lng = position.lng
          this.mapCenterHot.lat = position.lat
        }
      }
    },
    changeMore(tag) {
      if (tag === 1) {
        this.isMore = this.isMore === 0 ? 1 : 0
      } else {
        this.isMore = this.isMore === 0 ? 2 : 0
      }
    },
    handleMap({ BMap, map }) {
      this.map = map
      this.BMap = BMap
      this.getPoints()
    },
    getPoints() {
      findEbikeNewGisProfileList({}).then(res => {
        const list1 = res?.data?.allList || []
        list1.map(item => {
          for (const k in item) {
            if (k !== 'lng' && k !== 'lat' && k !== 'status' && k !== 'lockStatus' && k !== 'batteryTemp') {
              item[k] = item[k] || '--'
            }
          }
        })
        this.allPoints = JSON.parse(JSON.stringify(list1))
        // if (status === 2) {
        this.tabs[0].value = list1.length
        // } else if (status === 1) {
        //   this.tabs[1].value = list.length
        // } else {
        //   this.tabs[2].value = list.length
        // }
        const list2 = res?.data?.onlineList || []
        list2.map(item => {
          for (const k in item) {
            if (k !== 'lng' && k !== 'lat' && k !== 'status' && k !== 'lockStatus' && k !== 'batteryTemp') {
              item[k] = item[k] || '--'
            }
          }
        })
        this.onlineList = JSON.parse(JSON.stringify(list2))
        this.tabs[1].value = list2.length
        const list3 = res?.data?.faultList || []
        list3.map(item => {
          for (const k in item) {
            if (k !== 'lng' && k !== 'lat' && k !== 'status' && k !== 'lockStatus' && k !== 'batteryTemp') {
              item[k] = item[k] || '--'
            }
          }
        })
        this.faultList = JSON.parse(JSON.stringify(list3))
        this.tabs[2].value = list3.length
        var dataList = []
        if (this.activeName === 'all') {
          dataList = this.allPoints
        } else if (this.activeName === 'online') {
          dataList = this.onlineList
        } else if (this.activeName === 'error') {
          dataList = this.faultList
        }
        if (this.mapType === this.$t('operate.name74')) {
          this.initBaiduMap(dataList)
        } else {
          this.initGoogleMap(dataList)
        }
      })
    },
    initBaiduMap(dataList) {
      this.hotmarkersbaidu = []
      const hots = new Map()
      this.points = dataList.map((item, index) => {
        if (item.lng) {
          const bikepoints = coordtransform.wgs84togcj02(item.lng, item.lat)
          const bikepointss = coordtransform.gcj02tobd09(bikepoints[0], bikepoints[1])
          item.lng = Number(bikepointss[0])
          item.lat = Number(bikepointss[1])
        } else {
          item.lng = Math.random() * 40 + 85
          item.lat = Math.random() * 30 + 21
        }
        if (!hots.has(`${item.lng},${item.lat}`)) {
          hots.set(`${item.lng},${item.lat}`, { lng: item.lng, lat: item.lat, count: 1 })
        } else {
          hots.set(`${item.lng},${item.lat}`, { lng: item.lng, lat: item.lat, count: hots.get(`${item.lng},${item.lat}`).count + 1 })
        }
        if (index === 0) {
          this.mapCenterHot.lng = item.lng
          this.mapCenterHot.lat = item.lat
        }
        return {
          ...item
        }
      })
      hots.forEach((value, key) => {
        this.hotmarkersbaidu.push(value)
      })
      if (this.hotmarkersbaidu.length > 0) {
        this.maxHot = Math.max(...this.hotmarkersbaidu.map(item => item.count))
      } else {
        this.maxHot = 0
      }
      // this.addPoints()
      // console.log('hotmarkersbaidu', this.hotmarkersbaidu)
      // console.log('hotmarkersbaidu', this.maxHot)
      this.warnList = this.points
      const markers = this.points.map(item => { return { lng: item.lng, lat: item.lat } })
      var view = this.map.getViewport(markers) // markers中包含了所有点
      this.mapZoom = view.zoom // 缩放级别
      this.mapCenter = view.center // 中心点经纬度坐标
    },
    initGoogleMap(dataList) {
      this.points = dataList.map(item => {
        if (item.lng) {
          const bikepoints = coordtransform.wgs84togcj02(item.lng, item.lat)
          item.lng = Number(bikepoints[0])
          item.lat = Number(bikepoints[1])
        }
        return {
          ...item
        }
      })
      this.warnList = this.points
      // console.log('warnList====', this.warnList)
      this.warnList.map((item) => {
        // console.log('1111===', item)
        this.hotmarkersgoole.push({ lng: item.lng, lat: item.lat })
        item.infoText =
        '<div><span>' + this.$t('bike.name65') + '</span>' + item.ebikeId + '</div>' +
        '<div><span>' + this.$t('bike.name295') + '</span>' + item.ebikeCode + '</div>' +
        '<div><span>' + this.$t('bike.name492') + '</span>' + item.mac + '</div>' +
        '<div><span>' + this.$t('bike.name493') + '</span>' + item.tenantName + '</div>' +
        '<div><span>' + this.$t('bike.name168') + '</span>' + item.keepliveTime + '</div>' +
        '<div><span>' + this.$t('bike.name171') + '</span>' + item.alt + '</div>' +
        '<div><span>' + this.$t('bike.name216') + '</span>' + (item.speed === '--' ? '--' : Number(item.speed / 10).toFixed(1)) + '</div>' +
        '<div><span>' + this.$t('bike.name217') + '</span>' + item.soc + '</div>' +
        '<div><span>' + this.$t('bike.name494') + '</span>' + [this.$t('home.name28'), this.$t('home.name29')][item.lockStatus] + '</div>' +
        '<div><span>' + this.$t('bike.name35') + '</span>' + [this.$t('bike.name113'), this.$t('bike.name228'), this.$t('home.name30')][item.status] + '</div>' +
        '<div><span>' + this.$t('bike.name220') + '</span>' + (Number(item.batteryTemp) + Number(item.batteryTemperatureShowDeviation)) + '</div>'
      })
    },
    async infowindowgoole (item, idx) {
      // console.log('item===', item)
      this.infoWindowPosgoole = { lng: item.lng, lat: item.lat }
      this.infoOptionsgoole.content = item.infoText
      this.mapCenter = {
        lat: item.lat,
        lng: item.lng
      }
      if (this.currentMidxgoole === idx) {
        this.infoWinOpengoole = !this.infoWinOpengoole
      } else {
        this.infoWinOpengoole = true
        this.currentMidxgoole = idx
      }
    },
    changeMap() {
      this.getPoints()
    },
    handleClick(item) {
      this.infoWinOpengoole = false
      this.curPoint = ''
      if (item.type !== this.activeName) {
        this.activeName = item.type
        this.infoWindowShow = false
        this.getPoints()
        // this.mapZoom = 10
        // console.log('=this.activeName==', this.activeName)
        // if (this.activeName === 'all') {
        //   this.warnList = this.allPoints
        // } else if (this.activeName === 'online') {
        //   this.warnList = this.onlineList
        // } else if (this.activeName === 'error') {
        //   this.warnList = this.faultList
        // }
        // console.log('====', item)
        // this.getPoints(item.typevalue)
        // this.warnList = item.typevalue !== '' ? this.points.filter(chi => chi.status === item.typevalue) : this.points
      }
    },
    changeMarker(ebikeId) {
      if (this.mapType === this.$t('operate.name74')) {
        this.points.map((item) => {
          if (ebikeId === item.ebikeId) {
            this.mapZoom = 20
            this.mapCenter.lng = item.lng
            this.mapCenter.lat = item.lat
            this.infoWindow = item
            setTimeout(() => {
              this.infoWindowShow = true
            }, 100)
          }
        })
      } else {
        this.points.map((item) => {
          if (ebikeId === item.ebikeId) {
            this.mapGZoom = 22
            this.infoWindowPosgoole = { lng: item.lng, lat: item.lat }
            this.infoOptionsgoole.content = item.infoText
            this.mapCenter = {
              lat: item.lat,
              lng: item.lng
            }
            this.infoWinOpengoole = true
          }
        })
      }
    },
    closeInfo() {
      this.infoWindowShow = false
    },
    clickMarker(item) {
      if (this.mapType === this.$t('operate.name74')) {
        this.mapZoom = 20
        this.infoWindow = item
        setTimeout(() => {
          this.mapCenter.lng = item.lng
          this.mapCenter.lat = item.lat
          this.infoWindowShow = true
        }, 100)
      } else {
        this.mapGZoom = 22
        this.infoWindowPosgoole = { lng: item.lng, lat: item.lat }
        this.infoOptionsgoole.content = item.infoText
        this.mapCenter = {
          lat: item.lat,
          lng: item.lng
        }
        this.infoWinOpengoole = true
      }
    }
  }
}
</script>
<style>
.gm-style-iw{
  font-family: "PuHuiTi-400";
}
.gm-style .gm-style-iw-c{
  width: 280px;
  border-radius: 0px;
}
.gm-ui-hover-effect{
  /* width: 35px !important; */
  /* height: 30px !important; */
  margin: -10px !important;
  padding: 5px !important;
}
</style>
<style lang="scss" scoped>
.realtime-container {
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  .open-view {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: 40%;
    /*border-top: 1px solid #999;*/
    /*border-bottom: 1px solid #999;*/
    .el-button {
      width: 120px;
      height: 15px;
      line-height: 15px;
      padding: 0;
    }
  }
  .top-map {
    height: 60%;
    position: relative;
    .search-view {
      position: absolute;
      top: 10px;
      left: 10px;
      z-index: 10;
    }
    .maps-change {
      position: absolute;
      top: 50px;
      left: 10px;
      z-index: 10;
    }
    .hot-gmap{
      position: absolute;
      width: 200px !important;
      height: 200px !important;
      bottom: 0;
      right: 0;
      z-index: 10;
      border: 1px solid #000;
    }
    .map-item {
      width: 100%;
      height: 100%;
      position: relative;
      .map {
        width: 100%;
        height: 100%;
      }
      .hot-map {
        position: absolute;
        width: 200px;
        height: 200px;
        bottom: 0;
        right: 0;
        z-index: 10;
        border: 1px solid #000;
      }
    }

  }
  .bottom-list {
    height: 40%;
    .tabs {
      display: flex;
      align-items: center;
      height: 30px;
      padding: 1px 0;
      &-item {
        padding: 0 50px;
        height: 30px;
        line-height: 30px;
        /*border: 1px solid #999;*/
        cursor: pointer;
        &.active {
          /*background: #0f73e6;*/
          color: #0f73e6;
          border-bottom: 1px solid #0f73e6;
        }
      }
    }
    .el-table {
      margin-top: 0 !important;
    }
  }

  &.isMore1 {
    .open-view {
      bottom: 0;
    }
    .top-map {
      height: calc(100%  - 15px);
    }
    .bottom-list {
      height: 0;
    }
  }
  &.isMore2 {
    .open-view {
      bottom: auto;
      top: 0;
    }
    .top-map {
      height: 0;
    }
    .bottom-list {
      height: 100%;
    }
  }
}
  .infowindow-view {
    font-size: 12px;
  }
</style>
<style lang="scss" scoped>

</style>
